const KB_CONSTANTS = {
  KB_COLLECTION: 'KB_COLLECTION',
  KB_ARTICLE: 'KB_ARTICLE',
  SOURCE_COLLECTION_TREE: 'collectionTree',
  SOURCE_LIST_TABLE: 'listViewTable',
  COL_TREE_REFETCH_EVENT_EMITTER: 'refetchCollectionTree',
  KB_LIST_TABLE_REFETCH_EVENT: 'refetchKbListTable',
  KB_FB_LIST_TABLE_REFETCH_EVENT: 'refetchFeedbackListTable',
  COLLECTION_TREE_DEPTH_OFFSET: 1
};

const COLLECTION_TREE_DEFAULT_CONDITIONS = {
  joinOperator: 'AND',
  operands: [
    {
      attribute: 'parent',
      operator: 'isEmpty'
    }
  ]
};

const ARTICLES_DEFAULT_CONDITIONS = {
  joinOperator: 'AND',
  operands: [
    {
      attribute: 'itemType',
      operator: 'is',
      value: KB_CONSTANTS.KB_ARTICLE
    }
  ]
};

const KB_ROUTE_ID = {
  ALL_ARTICLES: 'ALL_ARTICLES',
  DRAFT: 'DRAFTS',
  FEEDBACK: 'FEEDBACK',
  KB: 'kb',
  COLLECTION: 'collection'
};

const KB_ROUTE = {
  ALL_ARTICLE_VIEW: `/kb/${KB_ROUTE_ID.ALL_ARTICLES}/view`,
  DRAFT_ARTICLE_VIEW: `/kb/${KB_ROUTE_ID.DRAFT}/view`,
  FEEDBACK_VIEW: `/kb/${KB_ROUTE_ID.FEEDBACK}/view`,
  COLLECTION_VIEW: `/kb/collection`
};

export {
  KB_CONSTANTS,
  COLLECTION_TREE_DEFAULT_CONDITIONS,
  ARTICLES_DEFAULT_CONDITIONS,
  KB_ROUTE,
  KB_ROUTE_ID
};
